// extracted by mini-css-extract-plugin
export var inner = "Sidebar-module--inner--NE0Oo";
export var sidebar = "Sidebar-module--sidebar--G-oUa";